import React from 'react';
import MuiTablePagination, {TablePaginationProps} from '@material-ui/core/TablePagination';
import BrowsePaginationSkeleton from '../skeleton/BrowsePaginationSkeleton';
import {withStyles} from '@material-ui/core';
import {getDirectionStyles} from '../../../../utils/ThemeUtils';
import {DirectionAuto, TrackEvent} from '../../../../components';

const TablePagination = withStyles<string, undefined, TablePaginationProps & {component: string}>(
    theme => ({
        selectRoot: {
            marginLeft: getDirectionStyles(theme.direction)('8px', '32px'),
            marginRight: getDirectionStyles(theme.direction)('32px', '8px')
        },
        actions: {
            marginLeft: getDirectionStyles(theme.direction)('20px', '0'),
            marginRight: getDirectionStyles(theme.direction)('0', '20px')
        }
    })
)(MuiTablePagination);

export interface BrowsePaginationProps {
    page: number;
    totalPosts: number;
    postsPerPage: number;
    onPageChange: (page: number) => void;
    onPostsPerPageChange: (postsPerPage: number) => void;
    isRendering?: boolean;
}

const BrowsePagination = ({
    page,
    totalPosts,
    postsPerPage,
    onPageChange,
    onPostsPerPageChange,
    isRendering = false
}: BrowsePaginationProps) => {
    if (isRendering) {
        return <BrowsePaginationSkeleton />;
    }

    return (
        <TrackEvent
            interactionType="Click"
            eventCategory="MediaCreator"
            eventAction="ClickBrowseGamesPaginate">
            {trackEvent => (
                <TablePagination
                    component="div"
                    labelRowsPerPage=""
                    nextIconButtonText=""
                    backIconButtonText=""
                    count={totalPosts}
                    page={page}
                    onPageChange={(event, value) => {
                        onPageChange(value);
                    }}
                    SelectProps={{
                        onOpen: event => {
                            trackEvent('Begin', {
                                eventAction: 'ClickBrowseGamesPaginatePostsPerPage',
                                data: {opened: true}
                            });
                        }
                    }}
                    rowsPerPage={postsPerPage}
                    rowsPerPageOptions={[18, 36, 54, 72]}
                    onRowsPerPageChange={event => {
                        const value = parseInt(event.target.value, 10);
                        onPostsPerPageChange(value);
                    }}
                    labelDisplayedRows={({from, to, count}) => {
                        const label = `${from}-${to} of ${
                            count !== -1 ? count : `more than ${to}`
                        }`;
                        return <DirectionAuto>{label}</DirectionAuto>;
                    }}
                />
            )}
        </TrackEvent>
    );
};

export default BrowsePagination;
